const stats = [
  { value: '5000万+', label: '月活跃用户', icon: 'ri-user-line', colorClass: 'text-primary-600 bg-primary-100' },
  { value: '12万+', label: '累计文章发布', icon: 'ri-article-line', colorClass: 'text-accent-600 bg-accent-100' },
  { value: '3.2亿', label: '月均阅读量', icon: 'ri-fire-line', colorClass: 'text-secondary-600 bg-secondary-100' },
  { value: '200+', label: '合作媒体伙伴', icon: 'ri-group-line', colorClass: 'text-primary-600 bg-primary-100' },
];

export default function PlatformStats() {
  return (
    <section className="py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="max-w-3xl mx-auto text-center mb-12">
          <p className="text-xs text-foreground-500 font-medium tracking-widest uppercase mb-3">
            Platform Data
          </p>
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950 mb-5">
            平台<span className="text-accent-500">数据</span>
          </h2>
          <p className="text-foreground-600 leading-relaxed text-sm md:text-base">
            自上线以来，今日看料已发展成为中文互联网最具影响力的娱乐资讯平台之一，以下数据见证我们的成长。
          </p>
        </div>

        <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 md:gap-6">
          {stats.map((stat) => (
            <div
              key={stat.label}
              className="bg-background-50 rounded-2xl p-5 md:p-7 text-center"
            >
              <div className={`w-11 h-11 mx-auto mb-3 rounded-xl flex items-center justify-center ${stat.colorClass}`}>
                <i className={`${stat.icon} text-lg`}></i>
              </div>
              <div className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-1">
                {stat.value}
              </div>
              <p className="text-xs md:text-sm text-foreground-500">{stat.label}</p>
            </div>
          ))}
        </div>

        <div id="reviews" className="mt-14 md:mt-20">
          <div className="max-w-3xl mx-auto text-center mb-10">
            <p className="text-xs text-foreground-500 font-medium tracking-widest uppercase mb-3">
              User Reviews
            </p>
            <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950 mb-5">
              用户<span className="text-secondary-500">口碑</span>
            </h2>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-6">
            <div className="bg-background-50 rounded-2xl p-5 md:p-6">
              <div className="flex items-center gap-1 mb-3 text-accent-500">
                {[1, 2, 3, 4, 5].map((i) => (
                  <i key={i} className="ri-star-fill text-sm"></i>
                ))}
              </div>
              <p className="text-sm text-foreground-700 leading-relaxed mb-3">
                "自从发现了今日看料，每天必刷！吃瓜速度比微博还快，而且内容整理得很清晰，强烈推荐给所有吃瓜群众！"
              </p>
              <div className="flex items-center gap-2.5">
                <div className="w-8 h-8 rounded-full bg-primary-100 flex items-center justify-center">
                  <i className="ri-user-line text-primary-600 text-sm"></i>
                </div>
                <div>
                  <p className="text-xs font-medium text-foreground-950">吃瓜达人小王</p>
                  <p className="text-[10px] text-foreground-500">资深用户 · 2年</p>
                </div>
              </div>
            </div>

            <div className="bg-background-50 rounded-2xl p-5 md:p-6">
              <div className="flex items-center gap-1 mb-3 text-accent-500">
                {[1, 2, 3, 4, 5].map((i) => (
                  <i key={i} className="ri-star-fill text-sm"></i>
                ))}
              </div>
              <p className="text-sm text-foreground-700 leading-relaxed mb-3">
                "PP料价格信息很及时，作为一名采购经理，每天都会看PP料专区的行情分析，帮我在采购决策上省了不少钱。"
              </p>
              <div className="flex items-center gap-2.5">
                <div className="w-8 h-8 rounded-full bg-secondary-100 flex items-center justify-center">
                  <i className="ri-user-line text-secondary-600 text-sm"></i>
                </div>
                <div>
                  <p className="text-xs font-medium text-foreground-950">塑料行业老李</p>
                  <p className="text-[10px] text-foreground-500">采购经理 · 1年</p>
                </div>
              </div>
            </div>

            <div className="bg-background-50 rounded-2xl p-5 md:p-6">
              <div className="flex items-center gap-1 mb-3 text-accent-500">
                {[1, 2, 3, 4, 5].map((i) => (
                  <i key={i} className="ri-star-fill text-sm"></i>
                ))}
              </div>
              <p className="text-sm text-foreground-700 leading-relaxed mb-3">
                "内容更新快，排版也舒服，没有乱七八糟的广告弹窗。作为每天摸鱼必备的吃瓜神器，已经推荐给整个办公室了！"
              </p>
              <div className="flex items-center gap-2.5">
                <div className="w-8 h-8 rounded-full bg-accent-100 flex items-center justify-center">
                  <i className="ri-user-line text-accent-600 text-sm"></i>
                </div>
                <div>
                  <p className="text-xs font-medium text-foreground-950">互联网冲浪选手</p>
                  <p className="text-[10px] text-foreground-500">忠实用户 · 1.5年</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}